export const arrowRightPath = "<path d=\"M3 8 H13 M9 4 L13 8 L9 12\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
